/* global console */
import axios from "axios";
import { FilterOptions } from "../taskpane/domain/FilterOptions";
import { FilterQueryParameters } from "../taskpane/domain/FilterQueryParameters";
import { authHeader } from "./AuthHeader";
import { RoomQueryParameters } from "../taskpane/domain/RoomQueryParameters";
import { Room } from "../taskpane/domain/Room";

export async function getAvailableRooms(
  filterValues: RoomQueryParameters = new RoomQueryParameters()
): Promise<Room[]> {
  const url = `/archibus/api/v1/reservation/rooms${filterValues.toUrlParams()}`;
  const response = await callApi(url);
  return parseRooms(response.data);
}

export async function getRoomDetails(emails: string[]): Promise<Room[]> {
  const url = `/archibus/api/v1/reservation/roomdetails?emails=${emails.join(",")}`;
  const response = await callApi(url);
  return parseRooms(response.data);
}

function parseRooms(data: Object[]): Room[] {
  const rooms: Room[] = [];
  data.forEach((item: Object) => {
    rooms.push(new Room(item));
  });
  return rooms;
}

export async function getFilterOptions(
  filterValues: FilterQueryParameters = new FilterQueryParameters()
): Promise<FilterOptions> {
  let result: FilterOptions;
  if (filterValues.levels == "none") {
    // we don't need to query the server at this level
    // e.g. changed building when floor level is hidden
    // copy the ids from the query parameter to the result
    result = new FilterOptions(filterValues);
  } else {
    const url = `/archibus/api/v1/reservation/filters${filterValues.toUrlParams()}`;
    const response = await callApi(url);
    result = new FilterOptions(response.data);
  }
  return result;
}

async function callApi(url: string) {
  console.log("Calling " + url);
  const response = await axios.get(url, {
    headers: await authHeader(),
  });
  console.log(response);
  return response;
}
